import { Module } from 'vuex';
import { State } from '@/stores/environment/state';
import { Getters } from '@/stores/environment/getters';
import { Mutations } from '@/stores/environment/mutations';
import { Actions } from '@/stores/environment/actions';

export class EnvironmentStore implements Module<State, any> {
    public namespaced: boolean = true;
    public state: State = new State();
    public actions: Actions = new Actions();
    public getters: Getters = new Getters();
    public mutations: Mutations = new Mutations();
}
